import { MutableRefObject, useEffect, useRef } from 'react';
import { useReframe } from 'nike-re-framejs';
import { getMarketId } from '../components/Markets';
import { isMobile } from 'react-device-detect';
import { filterSport$ } from '../subs';

const useMarketHover: (columnId: string, index: number) => [MutableRefObject<any>] = (columnId, index) => {
    const derefSub = useReframe();
    const ref = useRef(null);
    const sportName = derefSub(filterSport$);
    const marketHeader = document.getElementById(getMarketId(sportName, columnId, index));
    useEffect(() => {
        const node = ref.current;
        if (!isMobile && node && marketHeader) {
            const onMouseOver = () => marketHeader?.classList.add('market-hover');
            const onMouseOut = () => marketHeader?.classList.remove('market-hover');
            node.addEventListener('mouseover', onMouseOver);
            node.addEventListener('mouseout', onMouseOut);
            return () => {
                node.removeEventListener('mouseover', onMouseOver);
                node.removeEventListener('mouseout', onMouseOut);
            };
        }
    }, [columnId, marketHeader]);
    return [ref];
};
export default useMarketHover;
